import { Stack, Typography } from "@mui/material";
import useIsLearnyDays from "../utils/useIsLearnyDays";
import useProducts from "../utils/useProducts";
import useCart from "../utils/useCart";
import imgSrc from "../../../img/learnydays.png";

const IMG_RATIO = 412 / 149;

const IMG_WIDTH = 250;

const IMG_HEIGHT = IMG_WIDTH / IMG_RATIO;

export default function LearnyDaysAlert(){
    const isLearnyDays = useIsLearnyDays();

    const { data: products } = useProducts();
    
    const { cart } = useCart();
    
   const show = cart.category === 'dentaire' && 
        !!products?.find(p => p.variant.id.startsWith( 'dpc')) &&
        isLearnyDays;

    if (!show) return <></>;
 
    return (
        <Stack sx={{ pt: 0, pb: 2, px: 8, borderRadius: '20px', bgcolor: '#1c1c24', }} alignItems="center">
            <img src={imgSrc} alt="LearnyDays" width={IMG_WIDTH} height={IMG_HEIGHT} />
            <Typography align="center" sx={{ color: 'white' }} variant="h6">
                Formez-vous tant que le DPC est encore là ! 
            </Typography>
            <Typography align="center" variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }} mt={1}>
                LearnyDays : <b>1 formation DPC = 1 formation DPC</b> <br />ou <b>-15% sur les MasterClass & LearnySpeed</b>
            </Typography>
        </Stack>
    );
}